import React, { Component } from 'react';
import numeral from 'numeral';
import moment from 'moment';

import URLS from '../../utils/urls';
import { translations } from '../../i18n/translations';

export default class CertificatePreview extends Component {
  render() {
    const {
      policy_number,
      insurer_serial_number,
      proposer_name,
      financier,
      duration_of_cover,
      start_date,
      quote_goods = [],
      conveyance_name,
      port_from_name,
      country_of_origin_name,
      town_to_name,
      port_to_name,
      total_sum_insured,
      excess,
      tra_pin,
      gross_direct_premium,
      pcf,
      insurance_training_levy,
      stamp_duty,
      premium,
      bank_name,
      agent_name,
      broker_name,
      clearing_agent,
      // ucr_number,
      qrcode,

      insurer_name,
      insurer_signature,
      insurer_logo
    } = this.props.quote;
    console.log(qrcode);
    return (
      <div className="clearfix certificate-wrapper">
        <div className="clearfix text-center">
          <h4 className="cert-header">
            Tanzania Imports Insurance Certificate
          </h4>
        </div>

        <table width="100%">
          <tbody>
            <tr className="no-border">
              <td
                style={{
                  height: '100px',
                  overflow: 'hidden',
                  position: 'relative',
                  width: '155px'
                }}
              >
                <img
                  className="pull-left"
                  src={URLS.siteURL + insurer_logo}
                  alt="Insurer Logo"
                  style={{
                    height: '125px',
                    position: 'absolute',
                    top: '-12px'
                  }}
                />
              </td>
              <td>
                <p className="text-center" style={{ paddingTop: '2em' }}>
                  Policy No: {policy_number || '-'}
                  <br />
                  Serial No: {insurer_serial_number || '-'}
                </p>
              </td>
              <td>
                <img
                  className="cert-qrcode"
                  src={URLS.siteURL + qrcode}
                  alt="QR Code"
                  style={{ float: 'right', padding: '1em', width: '100px' }}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <table className="table certificate-preview-table">
          <tbody>
            <tr className="no-border">
              <td colSpan="3">
                This cover note is to confirm that we are holding covered our
                insured in respect of marine cargo insurance under our standard
                policy the details of which are as follows:
              </td>
            </tr>
            <tr>
              <th>PROPOSER'S NAME</th>
              <td colSpan="2">
                <span id="proposer_name">{proposer_name || '-'}</span>
                <br />
                <span id="kra_pin">TRA PIN - {tra_pin || 'N/A'}</span>
              </td>
            </tr>
            <tr>
              <th>INTEREST/FINANCIER</th>
              <td colSpan="2">{financier || 'N/A'}</td>
            </tr>
            <tr>
              <th>CLASS OF INSURANCE</th>
              <td colSpan="2">MARINE CARGO (ALL RISKS) WAR, SRCC</td>
            </tr>
            <tr>
              <th>PERIOD OF INSURANCE</th>
              <td colSpan="2">
                <span id="duration_of_cover">{duration_of_cover}</span> days
                &nbsp; Starting from {moment(start_date).format('MMM Do, YYYY')}
              </td>
            </tr>
            <tr>
              <th>DESCRIPTION OF COVER</th>
              <td colSpan="2">
                INTERESTS: ON A CONSIGNMENT SAID TO CONTAIN:
                <br />
                {quote_goods.length > 0 ? (
                  <ul className="infolist">
                    {quote_goods.map((good, index) => {
                      return <li>-</li>;
                    })}
                  </ul>
                ) : null}
              </td>
            </tr>
            <tr>
              <th>CONVEYANCE:</th>
              <td colSpan="2">
                <span id="conveyance_used">{conveyance_name || 'NONE'}</span>
              </td>
            </tr>
            <tr>
              <th>VOYAGE:</th>
              <td colSpan="2">
                From
                <span id="port_from">
                  {port_from_name} {country_of_origin_name}
                </span>{' '}
                to &nbsp;
                <span id="town_to">{town_to_name}</span> via &nbsp;
                <span id="port_to">{port_to_name}</span>, Kenya
              </td>
            </tr>
            <tr>
              <th>SUM INSURED</th>
              <td colSpan="2">
                {translations.currency}
                <span id="total_sum_insured">
                  {numeral(total_sum_insured).format('0,0.00')}
                </span>
              </td>
            </tr>
            {false ? (
              <tr>
                <th>EXCESS</th>
                <td colSpan="2">
                  <span id="excess">{excess || '-'}</span>
                </td>
              </tr>
            ) : null}
            <tr>
              <th>PREMIUM</th>
              <td colSpan="2">
                {translations.currency}
                <span id="premium">
                  {numeral(gross_direct_premium).format('0,0.00')}
                </span>
              </td>
            </tr>
            <tr>
              <th>VAT</th>
              <td colSpan="2">
                {translations.currency}
                <span id="premium">
                  {numeral(gross_direct_premium * 0.18).format('0,0.00')}
                </span>
              </td>
            </tr>
            <tr>
              <th>POLICY HOLDERS FUND</th>
              <td colSpan="2">
                {translations.currency + numeral(pcf).format('0,0.00')}
              </td>
            </tr>
            <tr>
              <th>INSURANCE TRAINING LEVY</th>
              <td colSpan="2">
                {translations.currency +
                  numeral(insurance_training_levy).format('0,0.00')}
              </td>
            </tr>

            {false ? (
              <tr>
                <th>STAMP DUTY</th>
                <td colSpan="2">
                  {translations.currency + numeral(stamp_duty.format('0,0.00'))}
                </td>
              </tr>
            ) : null}

            <tr>
              <th>TOTAL CHARGES</th>
              <td colSpan="2">
                {translations.currency + numeral(premium).format('0,0.00')}
              </td>
            </tr>
            <tr>
              <th>AGENCY/BROKERAGE</th>
              <td colSpan="2">
                <span id="broker">
                  {bank_name || agent_name || broker_name || 'N/A'}
                </span>
              </td>
            </tr>
            <tr>
              <th>CLEARING AGENT</th>
              <td colSpan="2">
                <span id="clearing-agent"> {clearing_agent || 'N/A'} </span>
              </td>
            </tr>
            <tr>
              <th>SURVEY AGENTS</th>
              <td colSpan="2">OCEANIC MARINE SURVEYORS TANZANIA LIMITED</td>
            </tr>
          </tbody>
        </table>

        <div className="terms-content clearfix">
          <h4>Premium Payment Terms:</h4>
          <p>
            Premium amount shown above to be made in Tanzania Shillings. Where
            payments are in Dollars (or any foreign currency), the payment
            should be made immediately this certificate is issued to avoid any
            variance in exchange rates caused by delays. In the event of delayed
            payments, the dollars remitted should be based on the exchange rate
            applied on the marine cargo certficate and not at the date of
            payment.
          </p>
        </div>
        <div className="signature">
          <p>
            <strong>
              Signed on this date - {moment(start_date).format('MMM Do, YYYY')}{' '}
            </strong>
          </p>
          <img
            width="100"
            src={URLS.siteURL + insurer_signature}
            className="certificate-signature"
            alt="Signature"
          />
          <p>
            <strong>FOR AND ON BEHALF OF</strong>
          </p>
          <p>
            <strong>{insurer_name}</strong>
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/buy/CertificatePreview.jsx